import React, { Component } from "react";
import LayoutOperation from "../../../components/layout_operation";
// import { Router, Link } from "react-router-dom";
import { Input, DatePicker, Collapse, Table, Select, TreeSelect, Modal } from "antd";
// import JobDetailTable from "./job_detail_table/JobDetailTable";
// import AddBusModal from "./add_bus_modal/AddBusModal";
import ModalSuccess from "../../../components/Modal_Success";
import Api from "../../../services/ServiceApi";
import Cookies from "js-cookie";
import moment from "moment";
import AddBusModal from "./add_bus_modal/AddBusModal";
import { Redirect } from "react-router-dom";
import XLSX from 'xlsx';

const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];

const { Panel } = Collapse;
const { SHOW_PARENT } = TreeSelect;


class Jobdetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAddBusModalVisible: false,
            redirect: null,
            columns_Advertising: [
                {
                    title: 'Advertising Name',
                    dataIndex: 'advertise_list_id',
                    key: 'advertise_list_id',
                    render: (item) => (
                        <span className="font-thai-r font18 c-blue font-bold">{item}</span>
                    )
                },
                {
                    title: 'External Ads.',
                    dataIndex: '',
                    key: '',
                    render: (item) => {
                        var setMaster = [];
                        var defaultProps = [];
                        for (let i = 0; i < this.state.master_ad["filter_p_book_ext_ads_area"].length; i++) {
                            setMaster.push({
                                title: this.state.master_ad["filter_p_book_ext_ads_area"][i].filter_name,
                                value: this.state.master_ad["filter_p_book_ext_ads_area"][i].filter_value,
                                key: i,
                            })
                        }
                        if (item["fw"]) {
                            defaultProps.push("FW");
                        }
                        if (item["hw"]) {
                            defaultProps.push("HW");
                        }
                        if (item["qw"]) {
                            defaultProps.push("QW");
                        }
                        if (item["special"]) {
                            defaultProps.push("Special");
                        }
                        const tProps = {
                            treeData: setMaster,
                            value: defaultProps,
                            onChange: (value, setMaster) => this.onChangeSelect(value, item, setMaster, "External"),
                            treeCheckable: true,
                            showCheckedStrategy: SHOW_PARENT,
                            placeholder: 'Please select',
                            style: {
                                width: '100%',
                                fontSize: "16px"
                            },
                        }
                        return <TreeSelect {...tProps}  style={{ pointerEvents:  "none" }}  />
                    }
                },
                {
                    title: 'Internal Ads.',
                    dataIndex: '',
                    key: '',
                    render: (item) => {
                        var setMaster = [];
                        var defaultProps = [];
                        for (let i = 0; i < this.state.master_ad["filter_p_book_int_ads_area"].length; i++) {
                            setMaster.push({
                                title: this.state.master_ad["filter_p_book_int_ads_area"][i].filter_name,
                                value: this.state.master_ad["filter_p_book_int_ads_area"][i].filter_value,
                                key: i,
                            })
                        }

                        if (item["ib"]) {
                            defaultProps.push("IB");
                        }
                        if (item["hg"]) {
                            defaultProps.push("HG");
                        }
                        if (item["lcd"]) {
                            defaultProps.push("LCD");
                        }

                        const tProps = {
                            treeData: setMaster,
                            value: defaultProps,
                            onChange: (value, setMaster) => this.onChangeSelect(value, item, setMaster, "Internal"),
                            treeCheckable: true,
                            showCheckedStrategy: SHOW_PARENT,
                            placeholder: 'Please select',
                            style: {
                                width: '100%',
                                fontSize: "16px"
                            },
                        }
                        return <TreeSelect {...tProps}  style={{ pointerEvents:  "none" }}  />
                    }

                },
                {
                    title: 'Technique',
                    dataIndex: '',
                    key: '',
                    render: (item) => {
                        var setMaster = [];
                        var defaultProps = [];
                        for (let i = 0; i < this.state.master_ad["filter_technique"].length; i++) {
                            setMaster.push({
                                title: this.state.master_ad["filter_technique"][i].filter_name,
                                value: this.state.master_ad["filter_technique"][i].filter_value,
                                key: i,
                            })
                        }
                        if (item["2D"]) {
                            defaultProps.push("2D");
                        }
                        if (item["3D"]) {
                            defaultProps.push("3D");
                        }
                        if (item["led"]) {
                            defaultProps.push("LED");
                        }
                        if (item["reflective_film"]) {
                            defaultProps.push("Reflective_film");
                        }
                        const tProps = {
                            treeData: setMaster,
                            value: defaultProps,
                            onChange: (value, setMaster) => this.onChangeSelect(value, item, setMaster, "Technique"),
                            treeCheckable: true,
                            showCheckedStrategy: SHOW_PARENT,
                            placeholder: 'Please select',
                            style: {
                                width: '100%',
                                fontSize: "16px"
                            },
                        }
                        return <TreeSelect {...tProps} style={{pointerEvents:  "none" }} />
                    }
                },
                // {
                //     title: 'Action',
                //     dataIndex: '',
                //     key: '',
                //     render: (item) => (
                //         <>
                //             <img src={Api.absoluteUrl("/icon/icon_delete_bus.svg")} style={{
                //                 cursor: "pointer"
                //             }}
                //                 onClick={() => this.ondeleteAdvertising(item)} />
                //         </>
                //     )
                // },
            ],
            columns_bus_booking: [
                {
                    title: 'Plate No.',
                    dataIndex: 'license_plate',
                    key: 'license_plate',
                },
                {
                    title: 'Line No',
                    dataIndex: 'bus_line_name',
                    key: 'bus_line_name',
                },
                {
                    title: 'Area',
                    dataIndex: 'area_name',
                    key: 'area_name',
                },
                {
                    title: 'Division',
                    dataIndex: 'division_name',
                    key: 'division_name',
                },
                {
                    title: 'Bus No.',
                    dataIndex: 'bus_no',
                    key: 'bus_no',
                },
                {
                    title: 'Model',
                    dataIndex: 'model_name',
                    key: 'model_name',

                },
                {
                    title: "Previous Internal Ad",
                    dataIndex: "prev_internal_ad_name",
                    key: "remark",
                    render: (item) => ( 
                      item === null || item === "" ? "-" : item
                    )
                  },
                  {
                    title: "Previous External Ad",
                    dataIndex: "prev_external_ad_name",
                    key: "remark",
                    render: (item) => ( 
                      item === null || item === "" ? "-" : item
                    )
                  },
                  {
                    title: "Previous Uninstall",
                    dataIndex: "prev_uninstall_flag",
                    key: "prev_uninstall_flag",
                    render: (item) => {
                      {
                        return item === null || item === 0 || item === undefined
                          ?  <span className="badge badge-pill badge-primary font-thai-b font14">
                                Not Uninstalled
                             </span>
                          : <span className="badge badge-pill badge-success font-thai-b font14">
                                Uninstalled
                            </span>;
                      }
                    },
                  },
                {
                    title: 'Locked Type',
                    dataIndex: '',
                    key: '',
                    render: (item) => (
                        <>
                            <Select
                                showSearch
                                style={{ width: "100%", pointerEvents:  "none"   }}
                                placeholder="Select a person"
                                optionFilterProp="children"
                                value={item.booking_lock_type}
                                onChange={(e) => this.onChangeSelect(e, item, null, "Locked")}
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {this.state.master_ad["filter_p_book_lock_type"].map((item, index) => (
                                    <Select.Option value={item.filter_value}>{item.filter_name}</Select.Option>
                                ))}
                            </Select>
                        </>
                    )
                },
                {
                    title: 'Advertising',
                    dataIndex: '',
                    key: '',
                    render: (item) => {
                        var setMaster = [];
                        var defaultProps = [];
                        for (let i = 0; i < this.state.list_bus_booking_detail_ad.length; i++) {
                            setMaster.push({
                                title: this.state.list_bus_booking_detail_ad[i].advertise_list_id,
                                value: this.state.list_bus_booking_detail_ad[i].advertise_list_id,
                                key: i,
                            })
                        }
                        const tProps = {
                            treeData: setMaster,
                            value: this.state.value_advertising_name[item.index],
                            onChange: (value, setMaster) => this.onChangeSelect(value, item, setMaster, "Advertising"),
                            treeCheckable: true,
                            showCheckedStrategy: SHOW_PARENT,
                            placeholder: 'Please select',
                            style: {
                                width: '100%',
                                fontSize: "16px"
                            },
                        }
                        return <TreeSelect {...tProps}  style={{ pointerEvents:  "none" }} />

                    }
                },
                {
                    title: 'External Date - Start',
                    dataIndex: '',
                    key: '',
                    render: (item) => (
                        <>  
                            <DatePicker 
                                style={{ width: "100%", pointerEvents:  "none" }}
                                format={dateFormatList}
                                defaultValue=
                                {

                                    moment(item.booking_external_date).format("DD/MM/YYYY")
                                        === "Invalid date" ? null :
                                        moment(moment(item.booking_external_date).format("DD/MM/YYYY"), "DD/MM/YYYY")

                                }
                                onChange={(e) =>
                                    item.booking_external_date = moment(e).format("DD/MM/YYYY")
                                }

                            />
                        </>
                    )
                },
                {
                    title: 'External Date - End',
                    dataIndex: '',
                    key: '',
                    render: (item) => (
                        <>
                            <DatePicker 
                                
                                style={{ width: "100%", pointerEvents:  "none"  }}
                                format={dateFormatList}
                                defaultValue=
                                {

                                    moment(item.booking_external_date_end).format("DD/MM/YYYY")
                                        === "Invalid date" ? null :
                                        moment(moment(item.booking_external_date_end).format("DD/MM/YYYY"), "DD/MM/YYYY")

                                }

                                onChange={(e) =>
                                    item.booking_external_date_end = moment(e).format("DD/MM/YYYY")
                                }

                            />
                        </>
                    )
                },
                {
                    title: 'Internal Date - Start',
                    dataIndex: '',
                    key: '',
                    render: (item) => (
                        <>
                            <DatePicker 
                                
                                style={{ width: "100%",pointerEvents:  "none"  }}
                                format={dateFormatList}
                                defaultValue=
                                {

                                    moment(item.booking_internal_date).format("DD/MM/YYYY")
                                        === "Invalid date" ? null :
                                        moment(moment(item.booking_internal_date).format("DD/MM/YYYY"), "DD/MM/YYYY")

                                }

                                // onChange={(e) =>
                                //     item.booking_internal_date = moment(e).format("DD/MM/YYYY")
                                // }

                            />
                        </>
                    )
                },
                {
                    title: 'Internal Date - End',
                    dataIndex: '',
                    key: '',
                    render: (item) => (
                        <>
                            <DatePicker 
                                
                                style={{ width: "100%", pointerEvents:  "none"  }}
                                format={dateFormatList}
                                defaultValue=
                                {

                                    moment(item.booking_internal_date_end).format("DD/MM/YYYY")
                                        === "Invalid date" ? null :
                                        moment(moment(item.booking_internal_date_end).format("DD/MM/YYYY"), "DD/MM/YYYY")

                                }

                                // onChange={(e) =>
                                //     item.booking_internal_date_end = moment(e).format("DD/MM/YYYY")
                                // }
                            />
                        </>
                    )
                },
                {
                    title: 'Remark',
                    dataIndex: '',
                    key: '',
                    render: (item) => (
                        <>
                            <Input style={{pointerEvents:  "none" }} placeholder="Remark" allowClear 
                                    // onChange={(e) => this.onChangeSelect(e.target.value, item, null, "Remark")} 
                                    value={item.remark === null ? "" : item.remark} />
                        </>
                    )
                },
                // {
                //     title: 'Action',
                //     dataIndex: '',
                //     key: '',
                //     render: (item) => (
                //         <>
                //             <img src={Api.absoluteUrl("/icon/icon_delete_bus.svg")} style={{
                //                 cursor: "pointer"
                //             }}
                //                 onClick={() => this.onDeleteSub(item)} />
                //         </>
                //     )
                // },
            ],
            main_data: [],
            master_ad: [],
            tProps: {},
            visible_add: false,
            advertisingName: "",
            list_bus_booking_detail_ad: [],
            list_bus_booking: [],
            value_advertising_name: [],
            display_loding: false,
            modalstatus: false,
            booking_date: "",
            external_date: "",
            external_date_end: "",
            internal_date: "",
            internal_date_end: "",
            delete_ad: [],
            delete_sub: [],
        }
    }
    async componentDidMount() {
        const get_query_group_list_mastre = await Api.post("get_query_group_list", {
             "company_id": "1"
            , "operator_id": "3"
            , "project_id": "1"
            , "query_id": "17,18,10,21"
            , "query_module" : "bus"
            , "param_text": ""
            , "where_cond": ""
        });
        // const get_query_group_list = await Api.post("get_query_group_list", {
        //     "company_id": "1"
        //     , "operator_id": "3"
        //     , "project_id": "1"
        //     , "query_id": "14,15,16"
        //     , "query_module" : "bus"
        //     , "param_text": "@bus_booking_id:$" + Cookies.get("bus_booking_id")
        //     // , "param_text": "@bus_booking_id:$240"
        //     , "where_cond": ""
        // });
        const get_query_group_list = await Api.post("get_query_group_list", {
            "company_id": "1"
            , "operator_id": "3"
            , "project_id": "1"
            , "query_id": "14,30,16"           
            , "query_module" : "bus"
            , "param_text": "@bus_booking_id:$" + Cookies.get("bus_booking_id")
            // , "param_text": "@bus_booking_id:$240"
            , "where_cond": ""
        });

        for (let i = 0; i < get_query_group_list.data.data["list_bus_booking_detail_sub"].length; i++) {
            get_query_group_list.data.data["list_bus_booking_detail_sub"][i]["advertising_name"] = [];
            get_query_group_list.data.data["list_bus_booking_detail_sub"][i]["index"] = i;
            this.state.value_advertising_name[i] = get_query_group_list.data.data["list_bus_booking_detail_sub"][i].advertise_list_id === "" || get_query_group_list.data.data["list_bus_booking_detail_sub"][i].advertise_list_id === null ? [] : get_query_group_list.data.data["list_bus_booking_detail_sub"][i].advertise_list_id.split(",");
        }
        for (let i = 0; i < get_query_group_list.data.data.list_bus_booking_detail_ad.length; i++) {
            get_query_group_list.data.data.list_bus_booking_detail_ad[i]["is_active"] = 1;
        }

        this.setState(
            {
                main_data: get_query_group_list.data.data,
                master_ad: get_query_group_list_mastre.data.data,
                list_bus_booking_detail_ad: get_query_group_list.data.data.list_bus_booking_detail_ad,
                list_bus_booking: get_query_group_list.data.data["list_bus_booking_detail_sub"],
                display_loding: true
            }
        )
    }
    onHandleLock = async () => {
        this.savebus("locked");
        const act_lock = await Api.post("bus_lock_ins", {
            "bus_booking_id": Cookies.get("bus_booking_id")
            , "create_by": Cookies.get("userId")
        });
        if (act_lock.data.result.code === "p") {
            alert('locked success')
            this.setState({ redirect: "/bus_status_checking" });
        }

    }
    onChangeData = (value, type, item) => {
        if (type === "Internal") {
            var defaultValue = ["hg", "lcd", "ib"];
            for (let i = 0; i < defaultValue.length; i++) {
                item[defaultValue[i]] = false;
            }
            item[value.toLowerCase()] = true;
            this.setState({
                list_bus_booking_detail_ad: [...this.state.list_bus_booking_detail_ad]
            })
        }
    }
    onhandleAdvertising = () => {
        var setAddd = {
            "2D": false,
            "3D": false,
            "advertise_id": this.state.main_data.list_bus_booking_detail_main[0].advertise_id,
            "advertise_list_id": this.state.advertisingName,
            "advertise_position_type": "",
            "fw": false,
            "hg": false,
            "hw": false,
            "ib": false,
            "lcd": false,
            "led": false,
            "qw": false,
            "reflective_film": false,
            "special": false,
            "is_active": 1,
            "index": (this.state.list_bus_booking_detail_ad.length)
        };
        this.state.list_bus_booking_detail_ad.push(setAddd);
        this.setState({
            list_bus_booking_detail_ad: [...this.state.list_bus_booking_detail_ad],
            list_bus_booking: [...this.state.list_bus_booking],
            visible_add: false,
            advertisingName: ""
        })
    }
    setVisibleAddBusModal = () => {
        this.setState({
            isAddBusModalVisible: true
        })
    }
    setClose = () => {
        this.setState({
            isAddBusModalVisible: false
        })
    }

    ondeleteAdvertising = (item) => {
        item["is_active"] = 0;
        const result = this.state.list_bus_booking_detail_ad.filter(data => data.advertise_list_id != item.advertise_list_id);
        this.state.delete_ad.push(item);
        this.setState({
            list_bus_booking_detail_ad: []
        })
        this.state.list_bus_booking_detail_ad.push(result);
        this.setState({
            list_bus_booking_detail_ad: result,
            list_bus_booking: [...this.state.list_bus_booking],
            advertisingName: ""
        })
    }

    onDeleteSub = (item) => {
        item["is_active"] = 0;
        const result = this.state.list_bus_booking.filter(data => data.bus_id != item.bus_id);
        const result2 = this.state.main_data.list_bus_booking_detail_sub.filter(data => data.bus_id != item.bus_id);

        this.state.delete_sub.push(item);
        this.state.main_data["list_bus_booking_detail_sub"] = result2 ; 
        this.setState({
            list_bus_booking: []
        })
        this.state.list_bus_booking.push(result);
        this.setState({
            list_bus_booking: result,
            main_data:  this.state.main_data , 
            // list_bus_booking: [...this.state.list_bus_booking],
            advertisingName: ""
        })
    }

    onChangeSelect = (value, item, data, type) => {
        if (type === "External") {
            var masterFiled = ["fw", "hw", "qw", "special"];
            for (let r = 0; r < masterFiled.length; r++) {
                item[masterFiled[r]] = false
            }
            for (let i = 0; i < value.length; i++) {
                item[value[i].toLowerCase()] = true;
            }
            this.setState({
                list_bus_booking_detail_ad: [...this.state.list_bus_booking_detail_ad]
            })
        }
        if (type === "Internal") {
            var masterFiled = ["ib", "hg", "lcd"];
            for (let r = 0; r < masterFiled.length; r++) {
                item[masterFiled[r]] = false
            }
            for (let i = 0; i < value.length; i++) {
                item[value[i].toLowerCase()] = true;
            }
            this.setState({
                list_bus_booking_detail_ad: [...this.state.list_bus_booking_detail_ad]
            })
        }
        if (type === "Technique") {
            var masterFiled = ["2D", "3D", "led", "reflective_film"];
            for (let r = 0; r < masterFiled.length; r++) {
                item[masterFiled[r]] = false
            }
            for (let i = 0; i < value.length; i++) {
                item[value[i] === "3D" || value[i] === "2D" ? value[i] : value[i].toLowerCase()] = true;
            }
            this.setState({
                list_bus_booking_detail_ad: [...this.state.list_bus_booking_detail_ad]
            })
        }
        if (type === "Locked") {
            item["booking_lock_type"] = value;
            this.setState({
                list_bus_booking: [...this.state.list_bus_booking]
            })
        }
        if (type === "Advertising") {
            this.state.value_advertising_name[item.index] = value;
            this.setState({
                value_advertising_name: this.state.value_advertising_name
            })
        }
        if (type === "Remark") {
            item["remark"] = value;
            this.setState({
                list_bus_booking: [...this.state.list_bus_booking]
            })
        }
        if (type === "Customer") {
            item.customer = value;
            this.setState({
                main_data: this.state.main_data
            })
        }
        if (type === "AE") {
            item.ae = value;
            this.setState({
                main_data: this.state.main_data
            })
        }
        if (type === "Project") {
            item.project_name = value.substring(0, 1) === "-" ? value.substring(1, value.length) : value;
            this.setState({
                main_data: this.state.main_data
            })
        }
        if (type === "Booking_Date") {

            item.booking_date = moment(value).format("DD/MM/YYYY");
            this.setState({
                main_data: this.state.main_data
            })
        }
        if (type === "External_Date_Start") {
            item.booking_external_date = moment(value).format("DD/MM/YYYY");
            this.setState({
                main_data: this.state.main_data
            })
        }
        if (type === "External_Date_End") {
            item.booking_external_date_end = moment(value).format("DD/MM/YYYY");
            this.setState({
                main_data: this.state.main_data
            })
        }
        if (type === "Internal_Date_Start") {
            item.booking_internal_date = moment(value).format("DD/MM/YYYY");
            this.setState({
                main_data: this.state.main_data
            })
        }
        if (type === "Internal_Date_End") {
            item.booking_internal_date_end = moment(value).format("DD/MM/YYYY");
            this.setState({
                main_data: this.state.main_data
            })
        }


    };
    onhandleMaster = (master, data_list) => {

        var sertProps = [];
        var defaultProps = [];
        var setMaster = [];

        for (let i = 0; i < master.length; i++) {
            setMaster.push({
                title: master["filter_p_book_ext_ads_area"][i].filter_name,
                value: master["filter_p_book_ext_ads_area"][i].filter_value,
                key: i,
            })
        }
        for (let i = 0; i < data_list.length; i++) {
            data_list[i]["index"] = i;

            if (data_list[i]["fw"]) {
                defaultProps.push("FW");
            }
            if (data_list[i]["hw"]) {
                defaultProps.push("HW");
            }
            if (data_list[i]["qw"]) {
                defaultProps.push("QW");
            }
            if (data_list[i]["special"]) {
                defaultProps.push("Special");
            }
            sertProps.push({
                treeData: setMaster,
                value: defaultProps,
                onChange: (value, setMaster) => this.onChangeSelect(value, setMaster),
                treeCheckable: true,
                showCheckedStrategy: SHOW_PARENT,
                placeholder: 'Please select',
                style: {
                    width: '100%',
                },
            });
            defaultProps = [];
        }
        this.setState({
            tProps: sertProps,
        })

    }
    savebus = async (type) => {
        if (this.state.delete_ad.length > 0) {
            for (let i = 0; i < this.state.delete_ad.length; i++) {
                this.state.list_bus_booking_detail_ad.push(this.state.delete_ad[i]);
            }
        }

        if (this.state.delete_sub.length > 0) {
            for (let i = 0; i < this.state.delete_sub.length; i++) {
                this.state.main_data.list_bus_booking_detail_sub.push(this.state.delete_sub[i]);
            }
        }
        var setdatamain = {};
        var datapushsub = [];
        var setdataAd = [];
        for (let i = 0; i < this.state.main_data.list_bus_booking_detail_main.length; i++) {

            setdatamain["data_main"] = this.state.main_data.list_bus_booking_detail_main[i];
            setdatamain["data_main"]["create_by"] = Cookies.get("userId");
            setdatamain["data_main"]["is_active"] = this.state.main_data.list_bus_booking_detail_main[i].is_active ? 1 : 0;

            setdatamain["data_main"]["booking_external_date"] =
                this.converDate(this.state.main_data.list_bus_booking_detail_main[i].booking_external_date) === "Invalid date" ||
                    this.state.main_data.list_bus_booking_detail_main[i].booking_external_date === null ? null :
                    moment(this.converDate(this.state.main_data.list_bus_booking_detail_main[i].booking_external_date)).format("YYYY-MM-DD");

            setdatamain["data_main"]["booking_external_date_end"] =
                this.converDate(this.state.main_data.list_bus_booking_detail_main[i].booking_external_date_end) === "Invalid date" ||
                    this.state.main_data.list_bus_booking_detail_main[i].booking_external_date_end === null ? null :
                    moment(this.converDate(this.state.main_data.list_bus_booking_detail_main[i].booking_external_date_end)).format("YYYY-MM-DD");

            setdatamain["data_main"]["booking_internal_date"] =
                this.converDate(this.state.main_data.list_bus_booking_detail_main[i].booking_internal_date) === "Invalid date" ||
                    this.state.main_data.list_bus_booking_detail_main[i].booking_internal_date === null ? null :
                    moment(this.converDate(this.state.main_data.list_bus_booking_detail_main[i].booking_internal_date)).format("YYYY-MM-DD");

            setdatamain["data_main"]["booking_internal_date_end"] =
                this.converDate(this.state.main_data.list_bus_booking_detail_main[i].booking_internal_date_end) === "Invalid date" ||
                    this.state.main_data.list_bus_booking_detail_main[i].booking_internal_date_end === null ? null :
                    moment(this.converDate(this.state.main_data.list_bus_booking_detail_main[i].booking_internal_date_end)).format("YYYY-MM-DD");

            if (this.state.main_data.list_bus_booking_detail_main[i].booking_type === "IN") {
                setdatamain["data_main"]["internal_advertise_id"] = this.state.main_data.list_bus_booking_detail_main[i].advertise_id;
            }
            else {
                setdatamain["data_main"]["internal_advertise_id"] = this.state.main_data.list_bus_booking_detail_main[i].advertise_id;
                setdatamain["data_main"]["external_advertise_id"] = this.state.main_data.list_bus_booking_detail_main[i].advertise_id;
            }

        }
        for (let i = 0; i < this.state.main_data.list_bus_booking_detail_sub.length; i++) {
            var setadvertise_list_id = "";
            if (this.state.value_advertising_name[this.state.main_data.list_bus_booking_detail_sub[i]["index"]] != undefined) {
                for (let r = 0; r < this.state.value_advertising_name[this.state.main_data.list_bus_booking_detail_sub[i]["index"]].length; r++) {
                    setadvertise_list_id += this.state.value_advertising_name[this.state.main_data.list_bus_booking_detail_sub[i]["index"]][r] + ",";
                }
            }
            var ad_data = {
                "2D": null,
                "3D": null,
                "FW": null,
                "HG": null,
                "HW": null,
                "IB": null,
                "QW": null,
                "LCD": null,
                "LED": null,
                "bus_id": this.state.main_data.list_bus_booking_detail_sub[i].bus_id,
                "Special": null,
                "create_by": Cookies.get("userId"),
                "is_active": this.state.main_data.list_bus_booking_detail_sub[i]["is_active"],
                "advertise_id": this.state.main_data.list_bus_booking_detail_main[0].advertise_id,
                "booking_code": this.state.main_data.list_bus_booking_detail_main[0].booking_code,
                "booking_type": this.state.main_data.list_bus_booking_detail_main[0].booking_type,
                "booking_lock_type": this.state.main_data.list_bus_booking_detail_sub[i].booking_lock_type,
                "bus_booking_id": this.state.main_data.list_bus_booking_detail_sub[i].bus_booking_id,
                "Reflective_film": null,
                "advertise_list_id": this.state.value_advertising_name[this.state.main_data.list_bus_booking_detail_sub[i]["index"]] != undefined ? setadvertise_list_id.substring(0, setadvertise_list_id.length - 1) : "",
                "booking_external_date":
                    this.converDate(this.state.main_data.list_bus_booking_detail_sub[i].booking_external_date) === "Invalid date" ||
                        this.state.main_data.list_bus_booking_detail_sub[i].booking_external_date === null ? null :
                        moment(this.converDate(this.state.main_data.list_bus_booking_detail_sub[i].booking_external_date)).format("YYYY-MM-DD"),
                "booking_internal_date": this.converDate(this.state.main_data.list_bus_booking_detail_sub[i].booking_internal_date) === "Invalid date" ||
                    this.state.main_data.list_bus_booking_detail_sub[i].booking_internal_date === null
                    ? null :
                    moment(this.converDate(this.state.main_data.list_bus_booking_detail_sub[i].booking_internal_date)).format("YYYY-MM-DD"),
                "booking_external_date_end": this.converDate(this.state.main_data.list_bus_booking_detail_sub[i].booking_external_date_end) === "Invalid date" ||
                    this.state.main_data.list_bus_booking_detail_sub[i].booking_external_date_end === null ? null :
                    moment(this.converDate(this.state.main_data.list_bus_booking_detail_sub[i].booking_external_date_end)).format("YYYY-MM-DD"),
                "booking_internal_date_end": this.converDate(this.state.main_data.list_bus_booking_detail_sub[i].booking_internal_date_end) === "Invalid date" ||
                    this.state.main_data.list_bus_booking_detail_sub[i].booking_internal_date_end === null ? null :
                    moment(this.converDate(this.state.main_data.list_bus_booking_detail_sub[i].booking_internal_date_end)).format("YYYY-MM-DD"),
                "remark": this.state.main_data.list_bus_booking_detail_sub[i].remark
            }
            datapushsub.push(ad_data);
        }
        for (let i = 0; i < this.state.list_bus_booking_detail_ad.length; i++) {
            setdataAd.push({
                "2D": this.state.list_bus_booking_detail_ad[i]["2D"] ? 1 : 0,
                "3D": this.state.list_bus_booking_detail_ad[i]["3D"] ? 1 : 0,
                "FW": this.state.list_bus_booking_detail_ad[i]["fw"] ? 1 : 0,
                "HG": this.state.list_bus_booking_detail_ad[i]["hg"] ? 1 : 0,
                "HW": this.state.list_bus_booking_detail_ad[i]["hw"] ? 1 : 0,
                "IB": this.state.list_bus_booking_detail_ad[i]["ib"] ? 1 : 0,
                "QW": this.state.list_bus_booking_detail_ad[i]["qw"] ? 1 : 0,
                "LCD": this.state.list_bus_booking_detail_ad[i]["lcd"] ? 1 : 0,
                "LED": this.state.list_bus_booking_detail_ad[i]["led"] ? 1 : 0,
                "Special": this.state.list_bus_booking_detail_ad[i]["special"] ? 1 : 0,
                "create_by": Cookies.get("userId"),
                "is_active": this.state.list_bus_booking_detail_ad[i]["is_active"],
                "expire_date": null,
                "advertise_id": this.state.main_data.list_bus_booking_detail_main[0].advertise_id,
                "effective_date": moment(new Date()).format("YYYY-MM-DD"),
                "Reflective_film": this.state.list_bus_booking_detail_ad[i].reflective_film ? 1 : 0,
                "advertise_list_id": this.state.list_bus_booking_detail_ad[i].advertise_list_id,
                "advertise_position_type": this.state.list_bus_booking_detail_ad[i].advertise_position_type
            })
        }
      
        const get_query_group_list_mastre = await Api.post("booking_update", {
            data_main: setdatamain.data_main,
            data_detail: datapushsub,
            data_ad: setdataAd
        })

        if (get_query_group_list_mastre.data.result.code === "p") {
            if (type === "save") {
                this.setState({
                    modalstatus: true
                })
                Cookies.set("activeTab", 1, { expires: 1 })
            } else {
                Cookies.set("activeTab", 1, { expires: 1 })
            }

        }
        else {
            alert("Error")
        }
    }
    converDate = (item) => {
        if (item === null) {
            return null
        }
        else {
            if (moment(item, "DD/MM/YYYY").format("YYYY-MM-DD") === "Invalid date") {
                return moment(item).format("YYYY-MM-DD")
            }
            else {
                return moment(item, "DD/MM/YYYY").format("YYYY-MM-DD")
            }
        }
    }

    onHandleExport = () =>{
        Api.post("get_query_group_list",
            {
                "company_id": "1",
                "operator_id": "3",
                "project_id": "1",
                "query_id": "28",
                "query_module" : "BUS",
                "param_text": "@bus_booking_id:$" + Cookies.get("bus_booking_id"),
                "where_cond": ""
        }).then((response) => {
              console.log(response)
            if(response.data.result.code.toLowerCase() == "p"){
                var result_array = [];
                var setHerder = {};
                var booking_code = this.state.main_data.list_bus_booking_detail_main[0].booking_code;
                var customer_name = this.state.main_data.list_bus_booking_detail_main[0].customer;
                var project_name = this.state.main_data.list_bus_booking_detail_main[0].project_name;

                const wb = XLSX.utils.book_new();
                for (const [key, value] of Object.entries(response.data.data)) {
                  // console.log(`${key}: ${value}`);
                  for (let i = 0; i < response.data.data[`${key}`].length; i++) {
                    for (const [key_h, value_h] of Object.entries(response.data.data[`${key}`][i])) {
                      setHerder[`${key_h}`] = `${key_h}`;
                    }
                    result_array.push(response.data.data[`${key}`][i])
                  }
                  let binaryWS = XLSX.utils.json_to_sheet([setHerder, ...result_array], { skipHeader: true });
                  XLSX.utils.book_append_sheet(wb, binaryWS, `${key}`);
                  result_array = [];
                  setHerder = {};
                }
                XLSX.writeFile(wb, booking_code+"_"+customer_name+"_"+project_name+"_"+(moment(new Date()).format("YYYYMMDD"))+".xlsx");
            }
        })
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect} />
        }
        return (
            <LayoutOperation active={3}>
                {console.log(this.state.main_data)}
                <Modal
                    title={"Add Advertising"}
                    centered
                    visible={this.state.visible_add}
                    footer={null}
                    closable={false}
                    width={500}
                >
                    <div className="row">
                        <div className="col-6  text-center" ><span className="font-thai-r font18 c-blue font-bold" >Advertising Name</span></div>
                        <div className="col-6"><Input placeholder="Advertising Name" onChange={(e) => this.setState({ advertisingName: e.target.value })} value={this.state.advertisingName}></Input></div>
                        <div className="col-12 mt-3  text-center">
                            <button
                                type="reset"
                                className="btn btn-secondary"
                                onClick={() => this.setState({
                                    visible_add: false
                                })}
                            >
                                Close
                            </button>
                            <button
                                className="btn btn-success"
                                style={{
                                    color: "#fff",
                                    backgroundColor: "#28a745",
                                    borderColor: "#28a745",
                                }}
                                onClick={() => this.onhandleAdvertising()}
                            >
                                Add
                            </button>
                        </div>
                    </div>
                </Modal>
                {this.state.modalstatus ? (
                    <ModalSuccess
                        status="Successfully"
                        path_location="/MaxiOperation/job_detail"
                    />
                ) : null}


                {this.state.display_loding === true ?
                    <div className="wrapper-header" style={{ height: "350px" }}>
                        <div className="container-fluid">
                            <div className="d-flex justify-content-between mb-2">
                                {/* <Link className="font-thai-r fs-20 c-white" to="/ma_list">
                                    <i className="fas fa-chevron-left"></i>
                                    <span style={{ marginLeft: "5px", marginBottom: "20px" }}>
                                        Back
              </span>
                                </Link> */}
                                {/* <Link className="font-thai-r fs-20 c-white" to="/ma_list">
                                    <span style={{ marginLeft: "5px", marginBottom: "20px" }}>
                                        {"MA list > Detail Job"}
                                    </span>
                                </Link> */}
                            </div>
                            {/* Bus data display*/}
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="d-flex">
                                        <div className="mr-3 pt-2">
                                            <img src={Api.absoluteUrl("/icon/icon_bus_detail.svg")} style={{ marginTop: "7px" }} />
                                        </div>
                                        <div>
                                            <h2 className="font-thai-b fs-40 c-white mb-0">
                                                
                                                ID : {this.state.main_data.list_bus_booking_detail_main.length > 0 ?   this.state.main_data.list_bus_booking_detail_main[0].booking_code : null}
                                            </h2>
                                            <span className="font-thai-i fs-20 c-white">
                                                {this.state.main_data.list_bus_booking_detail_main.length > 0 ? this.state.main_data.list_bus_booking_detail_main[0].project_name : null } / Total {this.state.main_data.list_bus_booking_detail_main.length > 0 ? this.state.main_data.list_bus_booking_detail_main[0].total_bus : null} Bus
                                            </span>
                                            {/* <div className="mt-2">
                    <span className="badge badge-pill badge-success font-thai-b fs-14 mr-2">
                      Available
                    </span>
                    <span className="badge badge-pill badge-light font-thai-b fs-14 mr-2">
                      Booking
                    </span>
                  </div> */}
                                        </div>
                                    </div>
                                </div>
                                <div  className="col-4 text-center">
                                    <h2 className="font-mont-b fs-24 c-white mb-0">
                                                   VIEW ONLY MODE
                                    </h2>
                                </div>
                                <div className="col-4">
                                    <div className="d-flex justify-content-end">
                                        {/* <a
                                            className="btn btn-gray"
                                            onClick={() => { this.savebus("save") }}
                                            style={{ marginRight: "1vw", float: "right" }}
                                        >
                                            Save
                                        </a>
                                        <a
                                            href="#"
                                            className="btn btn-warning"
                                            onClick={() => { this.onHandleLock() }}
                                            style={{ marginRight: "2vw", float: "right" }}
                                        >
                                            <span>Locked</span>
                                        </a> */}
                                        <button
                                            className="btn btn-warning"
                                            onClick={() => { this.onHandleExport() }}
                                            style={{ marginRight: "2vw", float: "right" }}
                                        >
                                            <span>Export</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="wrapper-body">
                                <div className="container-fluid">
                                    <div className="row" style={{ marginTop: "40px" }}>
                                        <div className="col-12">
                                            {/* Booking Document panel*/}
                                            <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
                                                <Panel
                                                    header={
                                                        <div>
                                                            <img
                                                                src={Api.absoluteUrl("/icon/asset_detail.svg")}
                                                                className="mr-3"
                                                                alt="asset detail icon"
                                                            />
                                                            <span className="c-blue text-uppercase">
                                                                <span className="c-blue text-uppercase">
                                                                    Booking Document
                                                                </span>
                                                            </span>
                                                        </div>
                                                    }
                                                    key="1"
                                                >
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-3"><span className="font-thai-r font18 c-blue font-bold">Customer</span></div>
                                                            <div className="col-3"><span className="font-thai-r font18 c-blue font-bold">Project</span></div>
                                                            <div className="col-3"><span className="font-thai-r font18 c-blue font-bold">Booking Date</span></div>
                                                            <div className="col-3"><span className="font-thai-r font18 c-blue font-bold">AE</span></div>
                                                            <div className="col-3 mt-1">
                                                                <Input
                                                                    value={this.state.main_data["list_bus_booking_detail_main"][0]["customer"]}
                                                                    style={{pointerEvents:  "none" }}
                                                                    // onChange={(e) =>this.onChangeSelect(e.target.value, this.state.main_data["list_bus_booking_detail_main"][0], null, "Customer")}
                                                                    // className="c-black"
                                                                />
                                                            </div>
                                                            <div className="col-3 mt-1">
                                                                <Input value={this.state.main_data["list_bus_booking_detail_main"][0]["project_name"] === null ? "-" :
                                                                    this.state.main_data["list_bus_booking_detail_main"][0]["project_name"]}
                                                                    style={{pointerEvents:  "none" }}
                                                                    // onChange={(e) => this.onChangeSelect(e.target.value, this.state.main_data["list_bus_booking_detail_main"][0], null, "Project")}
                                                                    // className="c-black"
                                                                /></div>
                                                            <div className="col-3 mt-1">
                                                                <DatePicker  className="date-picker-c-black" style={{ width: "100%", pointerEvents:  "none"  }}
                                                                    format={dateFormatList}
                                                                    defaultValue=
                                                                    {

                                                                        moment(this.state.main_data["list_bus_booking_detail_main"][0]["booking_date"]).format("DD/MM/YYYY")
                                                                            === "Invalid date" ?
                                                                            null
                                                                            :
                                                                            moment(moment(this.state.main_data["list_bus_booking_detail_main"][0]["booking_date"]).format("DD/MM/YYYY"), "DD/MM/YYYY")

                                                                    }

                                                                    // onChange={(e) =>
                                                                    //     this.onChangeSelect(e, this.state.main_data["list_bus_booking_detail_main"][0], null, "Booking_Date")}
                                                                    // disabled
                                                                /></div>
                                                            <div className="col-3 mt-1">
                                                                <Input
                                                                    value={this.state.main_data["list_bus_booking_detail_main"][0]["ae"]}
                                                                    style={{pointerEvents:  "none" }}

                                                                    // onChange={(e) =>
                                                                    //     this.onChangeSelect(e.target.value, this.state.main_data["list_bus_booking_detail_main"][0], null, "AE")}
                                                                    // className="c-black"
                                                               />
                                                            </div>


                                                        </div>
                                                        <div className="row mt-2">
                                                            <div className="col-3"><span className="font-thai-r font18 c-blue font-bold">External Date - Start</span></div>
                                                            <div className="col-3"><span className="font-thai-r font18 c-blue font-bold">External Date - End</span></div>
                                                            <div className="col-3"><span className="font-thai-r font18 c-blue font-bold">Internal Date - Start</span></div>
                                                            <div className="col-3"><span className="font-thai-r font18 c-blue font-bold">Internal Date - End</span></div>
                                                            <div className="col-3 mt-1"> <DatePicker style={{ width: "100%", pointerEvents:  "none" }}
                                                                format={dateFormatList}
                                                                defaultValue=
                                                                {

                                                                    moment(this.state.main_data["list_bus_booking_detail_main"][0]["booking_external_date"]).format("DD/MM/YYYY")
                                                                        === "Invalid date" ? null :
                                                                        moment(moment(this.state.main_data["list_bus_booking_detail_main"][0]["booking_external_date"]).format("DD/MM/YYYY"), "DD/MM/YYYY")


                                                                }
                                                             
                                                                // onChange={(e) =>
                                                                //     this.onChangeSelect(e, this.state.main_data["list_bus_booking_detail_main"][0], null, "External_Date_Start")}
                                                            /></div>
                                                            <div className="col-3 mt-1"> <DatePicker style={{ width: "100%", pointerEvents:  "none" }}
                                                                format={dateFormatList}
                                                           
                                                                defaultValue=
                                                                {

                                                                    moment(this.state.main_data["list_bus_booking_detail_main"][0]["booking_external_date_end"]).format("DD/MM/YYYY")
                                                                        === "Invalid date" ? null :
                                                                        moment(moment(this.state.main_data["list_bus_booking_detail_main"][0]["booking_external_date_end"]).format("DD/MM/YYYY"), "DD/MM/YYYY")



                                                                }

                                                                // onChange={(e) =>
                                                                //     this.onChangeSelect(e, this.state.main_data["list_bus_booking_detail_main"][0], null, "External_Date_End")}
                                                            /></div>
                                                            <div className="col-3 mt-1"> <DatePicker style={{ width: "100%", pointerEvents:  "none" }}
                                                                format={dateFormatList}
                                                                defaultValue=
                                                                {

                                                                    moment(this.state.main_data["list_bus_booking_detail_main"][0]["booking_internal_date"]).format("DD/MM/YYYY")
                                                                        === "Invalid date" ? null :
                                                                        moment(moment(this.state.main_data["list_bus_booking_detail_main"][0]["booking_internal_date"]).format("DD/MM/YYYY"), "DD/MM/YYYY")


                                                                }
                                                                // className="c-black"
                                                                // onChange={(e) =>
                                                                //     this.onChangeSelect(e, this.state.main_data["list_bus_booking_detail_main"][0], null, "Internal_Date_Start")}
                                                            /></div>
                                                            <div className="col-3 mt-1">
                                                                <DatePicker style={{ width: "100%",  pointerEvents:  "none" }}
                                                                    format={dateFormatList}
                                                                    defaultValue=
                                                                    {

                                                                        moment(this.state.main_data["list_bus_booking_detail_main"][0]["booking_internal_date_end"]).format("DD/MM/YYYY")
                                                                            === "Invalid date" ? null :
                                                                            moment(moment(this.state.main_data["list_bus_booking_detail_main"][0]["booking_internal_date_end"]).format("DD/MM/YYYY"), "DD/MM/YYYY")

                                                                    }
                                                                
                                                                    // className="c-black"
                                                                    // onChange={(e) =>
                                                                    //     this.onChangeSelect(e, this.state.main_data["list_bus_booking_detail_main"][0], null, "Internal_Date_End")}

                                                                /></div>
                                                        </div>
                                                        <hr className="mt-5 mb-2" />
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <span className="font-thai-r font18 c-blue font-bold">Advertising List</span>
                                                            </div>
                                                            <div className="col-6" style={{ textAlign: "right" }}>
                                                                {/* <button
                                                                    onClick={() => this.setState({
                                                                        visible_add: true
                                                                    })}
                                                                    className="btn btn-blue"
                                                                >
                                                                    Add Advertising
                                                                </button> */}
                                                            </div>
                                                            <div className="col-12">
                                                                <Table columns={this.state.columns_Advertising} dataSource={this.state.list_bus_booking_detail_ad} pagination={false} />
                                                            </div>
                                                        </div>
                                                        <hr className="mt-3 mb-3" />
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <span className="font-thai-r font18 c-blue font-bold">Bus Booking : {this.state.main_data["list_bus_booking_detail_sub"].length}</span>
                                                            </div>
                                                            <div className="col-6" style={{ textAlign: "right" }}>
                                                                {/* <sapn className="mr-2" style={{
                                                                    color: "red"
                                                                }}>{"* กรุณา Save ก่อนเพิ่มรายการรถ"}</sapn> */}
                                                                {/* <button
                                                                    onClick={() => this.setVisibleAddBusModal()}
                                                                    className="btn btn-blue"
                                                                >
                                                                    Add Bus
                                                                </button> */}
                                                            </div>
                                                            <div className="col-12">
                                                                <Table columns={this.state.columns_bus_booking} dataSource={this.state.list_bus_booking} scroll={{ x: true }}   pagination={false} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Panel>
                                            </Collapse>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null}
                {this.state.isAddBusModalVisible ? (
                    // <AddBusNewModal handleVisible={this.setVisibleAddBusModal} />
                    <AddBusModal handleVisible={this.state.isAddBusModalVisible} handleCLose={this.setClose}
                        customer={this.state.main_data["list_bus_booking_detail_main"][0]["customer"]}
                        project_name={this.state.main_data["list_bus_booking_detail_main"][0]["project_name"]}
                        external_date={moment(
                            moment(this.state.main_data["list_bus_booking_detail_main"][0]["booking_external_date"] === null ? new Date() : this.state.main_data["list_bus_booking_detail_main"][0]["booking_external_date"]).format(
                                "YYYY-MM-DD"
                            )
                            ,
                            dateFormatList[0]
                        )}
                        internal_date={moment(
                            moment(this.state.main_data["list_bus_booking_detail_main"][0]["booking_internal_date"] === null ? new Date() : this.state.main_data["list_bus_booking_detail_main"][0]["booking_internal_date"]).format(
                                "YYYY-MM-DD"
                            )
                            ,
                            dateFormatList[0]
                        )}
                        bus_booking_id={this.state.main_data["list_bus_booking_detail_main"][0]["bus_booking_id"]}
                    />
                ) : null
                }
            </LayoutOperation>
            // {isAddBusModalVisible ? (
            //     // <AddBusNewModal handleVisible={setVisibleAddBusModal} />
            // <AddBusModal handleVisible={setVisibleAddBusModal} />
            //   ) : null}


        )

    }
}

export default Jobdetail;
